import { TEuDdpRecord } from 'redux/reducers/euDdp/types';
import { ETableStructureType } from 'ui/EasTable/types';
import { TBoxStructure } from './EasParamsBox/types';

export const euDdpBoxStructure: TBoxStructure<TEuDdpRecord> = {
	header: [],
	body: [
		{
			name: 'DDP Enabled',
			selector: 'ddpEnabled',
			type: ETableStructureType.BOOLEAN,
			show: true,
			editable: false,
		},
		{
			name: 'Street and building',
			selector: 'streetNo',
			type: ETableStructureType.STRING,
			show: true,
		},
		{
			name: 'Region',
			selector: 'region',
			type: ETableStructureType.STRING,
			show: true,
		},
		{
			name: 'City',
			selector: 'city',
			type: ETableStructureType.STRING,
			show: true,
		},
		{
			name: 'Postal Code',
			selector: 'postalCode',
			type: ETableStructureType.STRING,
			show: true,
		},
		{
			name: 'Country',
			selector: 'country',
			type: ETableStructureType.COUNTRY,
			show: true,
		},
		{
			name: 'Pricing Plan',
			selector: 'pricingPlanDisplayName',
			type: ETableStructureType.STRING,
			show: true,
		},
		{
			name: 'Personal Fixed Fee',
			selector: 'personalFixedFee',
			type: ETableStructureType.AMOUNT,
			show: true,
		},
		{
			name: 'Personal Percentage Fee',
			selector: 'personalPercentageFee',
			type: ETableStructureType.AMOUNT,
			currency: (item) => '%',
			show: true,
		},
		{
			name: 'Post-payment is allowed',
			selector: 'postPaymentAllowed',
			type: ETableStructureType.BOOLEAN,
			show: true,
			editable: true,
		},
		{
			name: 'Created At',
			selector: 'createdAt',
			type: ETableStructureType.DATE_TIME,
			show: true,
			editable: false,
		},
		{
			name: 'Created By',
			selector: 'createdBy',
			type: ETableStructureType.USER,
			show: true,
			editable: false,
		},
	],
	title: 'EU DDP',
};
